import React from 'react';
import { CellProps } from 'react-table';
import {
  ExtraFieldTableInfoFragment,
  FieldType,
} from '../../__generated__/graphql';
import { ExtraTableItemType, RecordWithExtraFields } from './types';
import { EmployeeWithAvatar } from '../Employee';
import { formatDateShort, parseDate } from '../../../../utils/dateUtils';

const EMPTY_VALUE = '---';

export function defaultLookupRenderer<T extends RecordWithExtraFields>(
  props: CellProps<ExtraTableItemType<T>>,
  field: ExtraFieldTableInfoFragment,
) {
  const referenceFragment =
    props.row.original.rawExtraFields[field.fieldApiName]?.referenceTo;
  // referenceFragment can be null in case if object doesn't implement AnyObject interface, in that case we can return props.value which is usually referenceObject.Name
  if (!referenceFragment) {
    return props.value ? <div>{props.value}</div> : <div>{EMPTY_VALUE}</div>;
  }
  if (referenceFragment.__typename === 'Project') {
    return <div>{referenceFragment.flair__Name__c}</div>;
  } else if (referenceFragment.__typename === 'Colleague') {
    return (
      <EmployeeWithAvatar
        employee={{
          firstName: referenceFragment.flair__First_Name__c ?? '',
          lastName: referenceFragment.flair__Last_Name__c ?? '',
          avatarUrl: referenceFragment.avatar?.url,
        }}
      />
    );
  }
  return <div>{props.value}</div>;
}

export function defaultSimpleRenderer<T extends RecordWithExtraFields>(
  props: CellProps<ExtraTableItemType<T>>,
  field: ExtraFieldTableInfoFragment,
) {
  if (!field.fieldInfo) {
    // that line is more for developer, so it is ok to have it untranslated here
    return <div>Not supported: {field.customFieldName}</div>;
  }
  if (!props.value) {
    return <div></div>;
  }
  switch (field.fieldInfo.type) {
    case FieldType.Textarea:
      return <div>{props.value}</div>;
    case FieldType.Date:
      return <div>{formatDateShort(parseDate(props.value))}</div>;
    case FieldType.Datetime:
      return <div>{parseDate(props.value).toLocaleString()}</div>;
    default:
      return <div>{props.value}</div>;
  }
}
